import React from 'react'
import { BottomSheet, Typography } from '@s4l/ds'
import cn from 'classnames'
import IconSearch from 'client/icons/Search'
import { useIntl } from 'react-intl'
import PaxesText from 'src/comps/Atom/PaxesText'
import { SearchMode } from 'src/types/search'
import styles from './styles.module.css'

const dateOptions = {
  day: '2-digit',
  month: 'short',
} as const

interface IMobileProps {
  readonly text?: string
  readonly checkIn: Date
  readonly checkOut: Date
  readonly paxes: {
    rooms: number
    adults: number
    children: number
  }
  readonly mode?: SearchMode
}

export default function MobilePill({
  text,
  checkIn,
  checkOut,
  paxes,
  mode = SearchMode.Full,
}: IMobileProps) {
  const intl = useIntl()

  const TitleVariant = {
    [SearchMode.Borderless]: 'body',
    [SearchMode.Full]: 'body',
    [SearchMode.Readonly]: 'caption',
  } as const

  const SubtitleSizes = {
    [SearchMode.Borderless]: 'l',
    [SearchMode.Full]: 'l',
    [SearchMode.Readonly]: 'm',
  } as const

  return (
    <BottomSheet.Trigger
      className={cn('searchForm', styles.searchSummary, {
        [styles.readonly]: mode === SearchMode.Readonly,
      })}
    >
      <div className={styles.textWrapper}>
        <Typography variant={TitleVariant[mode]} size="l" ellipsis bold>
          {text || intl.formatMessage({ id: 'search.placeholder' })}
          {mode === SearchMode.Readonly && <span>&nbsp;·&nbsp;</span>}
        </Typography>
        <Typography
          variant="caption"
          size={SubtitleSizes[mode]}
          ellipsis
          color="var(--color--neutral--600)"
          className="mt-2"
        >
          <span>{intl.formatDate(checkIn, dateOptions)}</span>
          <span>&nbsp;-&nbsp;</span>
          <span>{intl.formatDate(checkOut, dateOptions)}</span>
          <span>&nbsp;·&nbsp;</span>
          <PaxesText className={styles.paxesText} paxes={paxes} mode={SearchMode.Readonly} />
        </Typography>
      </div>
      {mode === SearchMode.Full && (
        <div className={styles.buttonSearch}>
          <IconSearch size={20} />
        </div>
      )}
    </BottomSheet.Trigger>
  )
}
